export default "__VITE_ASSET__fb88a623__"